import { useState } from 'react';
import SearchFilter from './SearchFilter';
import SearchResult from './SearchResult';

export default function SearchResults({
  query,
  results,
  onSelect,
  hasMore,
  isLoadingMore,
  onLoadMore,
}) {
  const [selectedType, setSelectedType] = useState(null);
  const allTypes = [...new Set(results.map((result) => result.type))];
  const filteredResults = selectedType
    ? results.filter((result) => result.type === selectedType)
    : results;

  return (
    <div className="w-full">
      {allTypes?.length > 1 && (
        <SearchFilter
          types={allTypes}
          results={results}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
        />
      )}
      <div className="max-h-[28rem] scroll-py-2 overflow-y-auto">
        {filteredResults.map((result) => (
          <SearchResult
            key={`search-result-${result.type}-${result.id}`}
            result={result}
            query={query}
            onClick={() => onSelect(result)}
          />
        ))}

        {/* Load more only when no type filter is active — filters run on the
            already-fetched pages, and further pages are unfiltered. */}
        {hasMore && !selectedType && (
          <button
            type="button"
            disabled={isLoadingMore}
            onClick={(e) => {
              e.stopPropagation();
              onLoadMore();
            }}
            className="border-none w-full py-2 text-sm text-gray-500 hover:text-gray-900 disabled:opacity-50"
          >
            {isLoadingMore ? 'Loading...' : 'Load more'}
          </button>
        )}
      </div>
    </div>
  );
}
